import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import Swiper from 'swiper/dist/js/swiper';
import { connect } from 'unistore/react';

import 'swiper/dist/css/swiper.css';

import actions from '~/scripts/state/actions';
import OverallResult from '~/scripts/OverallResult';
import Icon from '~/core/scripts/components/Icon';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import config from '../config';

const isSmallScreen = !is768Query();

class AnalysisChooser extends PureComponent {
  componentDidMount() {
    this.initSwiper();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAnalysisMode !== this.props.isAnalysisMode) {
      this.initSwiper();
    }
  }

  initSwiper() {
    if (!this.props.isAnalysisMode) {
      return false;
    }

    if (this.swiper) {
      this.swiper.destroy();
    }

    this.swiper = new Swiper(this.container, {
      slidesPerView: isSmallScreen ? 1 : 'auto',
      navigation: {
        nextEl: '.swipe__next',
        prevEl: '.swipe__prev',
      },
      on: {
        slideChange: () => {
          if (!isSmallScreen) {
            return false;
          }

          this.props.setAnalysis(config[this.swiper.activeIndex]);
        }
      }
    });
  }

  onToggleAnalysis(evt) {
    evt.stopPropagation();

    if (isSmallScreen) {
      const nextAnalysis = this.props.isAnalysisMode ? {} : config[0];
      this.props.setAnalysis(nextAnalysis);
    }

    this.props.toggleAnalysisMode();
  }

  onClose(evt) {
    evt.stopPropagation();
    this.props.setAnalysis(false);
  }

  renderSlide(slideData, index) {
    const { selectedAnalysis } = this.props;

    return (
      <div
        key={`swiper__slide-${index}`}
        className={classnames('slide', 'swiper-slide', { 'is-active': selectedAnalysis.name === slideData.name })}
        onClick={() => this.props.setAnalysis(slideData)}
      >
        <div className="slide__close" onClick={evt => this.onClose(evt)}>
          <Icon type="close" />
        </div>
        <div className="slide__title">{slideData.label}</div>
        <div className="slide__description">{slideData.description}</div>
      </div>
    );
  }

  renderSlides() {
    const { hasDataAnalysis, isAnalysisMode } = this.props;
    const showOverlay = hasDataAnalysis && !isAnalysisMode;

    return (
      <Fragment>
        {showOverlay && (
          <div className="analysischooser__overlay" onClick={evt => this.onToggleAnalysis(evt)}>
            <div className="analysischooser__overlay-text">
              Wahl-Analyse aktivieren
            </div>
          </div>
        )}
        <div className="swipe__prev swipe__btn">
          <Icon type="down" />
        </div>
        <div ref={ref => this.container = ref} className="swiper-container">
          <div className="swiper-wrapper">
            {config.map((d,i) => this.renderSlide(d, i))}
          </div>
        </div>
        <div className="swipe__next swipe__btn">
          <Icon type="down" />
        </div>
      </Fragment>
    )
  }

  renderResult() {
    return <OverallResult isCompact />;
  }

  render() {
    const { hasDataAnalysis, isAnalysisMode } = this.props;
    const buttonLabel = isAnalysisMode ? 'Zur Karte' : 'Analyse';
    const showActivateButton = isSmallScreen || hasDataAnalysis;
    const showSlides = !isSmallScreen || (isSmallScreen && isAnalysisMode);

    return (
      <div className="analysischooser">
        {showActivateButton && (
          <button
            className="activate btn circle"
            onClick={(evt) => this.onToggleAnalysis(evt)}
          >
            {buttonLabel}
          </button>
        )}
        {showSlides ? this.renderSlides() : this.renderResult()}
      </div>
    );
  }
}

export default connect(state => ({
  selectedAnalysis: state.selectedAnalysis,
  hasDataAnalysis: state.hasDataAnalysis,
  isAnalysisMode: state.isAnalysisMode
}), actions)(AnalysisChooser);
